import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';
import { FiltersFormNonRecoverableErrors } from './list/types';

export const initialValues: FiltersFormNonRecoverableErrors = {
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PageNonRecoverableErrorsInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValues}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageNonRecoverableErrorsInitializer.displayName =
  'Page non recoverable errors initializer component';

export default PageNonRecoverableErrorsInitializer;
